import sessionManager from "../utils/sessionManager";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";

const useLogout = () => {
  const navigate = useNavigate();
  const { logout: authLogout } = useAuth();

  const logout = async () => {
    await sessionManager.clearSession();
    authLogout(); // Update AuthContext
    navigate("/auth", { replace: true });
  };

  return logout;
};

export default useLogout;
